import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import './App.css';

// Providers
import { AuthProvider } from './contexts/AuthContext';

// Routing
import AppRouter from './routes/AppRouter';

// UI Components
import { Toaster } from './components/ui/sonner';

/**
 * App - Main application entry point
 * 
 * Architecture:
 * - AuthProvider: Manages authentication state
 * - BrowserRouter: Enables client-side routing
 * - AppRouter: Contains all route definitions
 * - Toaster: Global toast notifications
 */
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <AppRouter />
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
